<template>
  <section>
    <v-card flat class="mt-5">
      <v-form>
        <div class="px-3">
          <v-card-text class="pt-5">
            <v-row>
              <v-col cols="12" sm="8" md="6">
                <v-text-field
                  v-model="lastname"
                  label="Nom"
                  outlined
                  dense
                ></v-text-field>

                <v-text-field
                  v-model="firstname"
                  label="Prénom"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="8" md="6">
                <v-text-field
                  v-model="email"
                  label="E-mail"
                  outlined
                  dense
                ></v-text-field>

                <!-- new password -->
                <v-text-field
                  v-model="newPassword"
                  :type="isNewPasswordVisible ? 'text' : 'password'"
                  :append-icon="
                    isNewPasswordVisible
                      ? icons.mdiEyeOffOutline
                      : icons.mdiEyeOutline
                  "
                  label="Mot de passe"
                  outlined
                  dense
                  hint="Assurez-vous qu'il contient au moins 8 caractères."
                  persistent-hint
                  @click:append="isNewPasswordVisible = !isNewPasswordVisible"
                ></v-text-field>

                <!-- confirm password -->
                <v-text-field
                  v-model="cPassword"
                  :type="isCPasswordVisible ? 'text' : 'password'"
                  :append-icon="
                    isCPasswordVisible
                      ? icons.mdiEyeOffOutline
                      : icons.mdiEyeOutline
                  "
                  label="Confirmez le mot de passe"
                  outlined
                  dense
                  class="mt-3"
                  @click:append="isCPasswordVisible = !isCPasswordVisible"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="4"
                md="6"
                class="d-none d-sm-flex justify-center position-relative"
              >
                <v-img
                  contain
                  max-width="250"
                  src="@/assets/images/logo.png"
                ></v-img>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-btn
              @click="verifyPasswordAndEmail()"
              color="primary"
              class="me-3 mt-3"
              style="background-color: #A8FE39; color:#0B0B0B"
            >
              Save changes
            </v-btn>
            <v-btn color="secondary" outlined class="mt-3">
              Cancel
            </v-btn>
          </v-card-text>
        </div>

        <!-- divider -->
        <v-divider></v-divider>

        <div class="pa-3">
          <v-card-title class="flex-nowrap">
            <v-icon class="text--primary me-3">
              {{ icons.mdiKeyOutline }}
            </v-icon>
            <span class="text-break">Exigences de mot de passe :</span>
          </v-card-title>

          <v-card-text class="text-left mx-auto">
            <v-avatar color="primary" class="primary mb-4" rounded>
              <v-icon size="25" color="white">
                {{ icons.mdiLockOpenOutline }}
              </v-icon>
            </v-avatar>
            <p class="text-base text--primary font-weight-semibold">
              Minimum 8 caractères : plus c'est mieux.
            </p>
            <p class="text-base text--primary font-weight-semibold">
              Au moins un caractère Majuscule.
            </p>
            <p class="text-base text--primary font-weight-semibold">
              Au moins un chiffre, un symbole ou un espace.
            </p>
          </v-card-text>

          <!-- action buttons -->
        </div>
      </v-form>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogVisible" max-width="600">
        <v-card color="text-center">
          <v-card-text class="d-flex flex-column justify-center align-center">
            <v-avatar v-if="!valid" color="error" class="mt-10" icon size="50">
              <v-icon size="2rem" color="white">
                {{ icons.mdiAlertCircleOutline }}
              </v-icon>
            </v-avatar>
            <v-avatar v-if="valid" color="success" class="mt-10" icon size="50">
              <v-icon size="2rem" color="white">
                {{ icons.mdiAccountCheck }}
              </v-icon>
            </v-avatar>
          </v-card-text>
          <v-card-text
            ><h3 style="color: black;">{{ passwordError }}</h3></v-card-text
          >
          <v-card-text>
            <v-btn
              v-if="!valid"
              @click="dialogVisible = false"
              color="primary"
              class="mt-4"
              style="background-color: #A8FE39; color:#0B0B0B"
            >
              fermer
            </v-btn>
            <v-btn
              v-if="valid"
              @click="addUser()"
              color="primary"
              class="mt-4"
              style="background-color: #A8FE39; color:#0B0B0B"
            >
              Confirmer
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiKeyOutline,
  mdiLockOpenOutline,
  mdiEyeOffOutline,
  mdiEyeOutline,
  mdiAlertCircleOutline,
  mdiAccountCheck,
} from "@mdi/js";
import { ref } from "@vue/composition-api";
import firebase from "firebase/compat/app";
import "firebase/auth";
import Constant from "@/utils/constants";

export default {
  setup() {
    const isCurrentPasswordVisible = ref(false);
    const isNewPasswordVisible = ref(false);
    const isCPasswordVisible = ref(false);
    const currentPassword = ref("");
    const newPassword = ref("");
    const cPassword = ref("");

    return {
      user: {
        firstname: "",
        lastname: "",
        role: "",
        email: "",
      },
      valid: false,
      email: null,
      lastname: null,
      firstname: null,
      passwordError: "",
      dialogVisible: false,
      isCurrentPasswordVisible,
      isNewPasswordVisible,
      currentPassword,
      isCPasswordVisible,
      newPassword,
      cPassword,
      icons: {
        mdiKeyOutline,
        mdiLockOpenOutline,
        mdiEyeOffOutline,
        mdiEyeOutline,
        mdiAlertCircleOutline,
        mdiAccountCheck,
      },
    };
  },
  methods: {
    async addUser() {
      const createdBy = firebase.auth().currentUser;

      const createdByMail = createdBy.email;
      try {
        // Create the user account using Firebase Authentication
        this.user.firstname = this.firstname;
        this.user.lastname = this.lastname;
        this.user.role = "ADMIN";
        this.user.email = this.email;
        const auth = firebase.auth();
        const userCredential = await auth.createUserWithEmailAndPassword(
          this.email,
          this.newPassword
        );
        const response = await fetch(Constant.QORANI + "user/register", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.user),
        });

        try {
        } catch (error) {
          alert(
            "Une erreur est survenue lors de l'ajout d'utulisateur', veuillez réessayez plus tard, Merci."
          );
        }
        this.passwordError = "";

        this.dialogVisible = false;
        alert("Account created successfully!");
        window.location.reload();
      } catch (error) {
        this.passwordError = error.message;
        this.showDialog();
      }
    },
    verifyPasswordAndEmail() {
      const emailFormatRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email format regular expression
      const minLength = 8;
      const uppercaseRegex = /[A-Z]/;
      const specialCharsRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/\-="']/;
      const digitRegex = /\d/;

      if (!this.email) {
        this.passwordError = "e-mail est requis.";
        this.valid = false;
        this.showDialog();
      } else if (!emailFormatRegex.test(this.email)) {
        this.passwordError = "Format e-mail invalide.";
        this.valid = false;
        this.showDialog();
      } else if (!this.newPassword) {
        this.passwordError = "Mot de passe requis.";
        this.valid = false;
        this.showDialog();
      } else if (this.newPassword.length < minLength) {
        this.passwordError =
          "Le mot de passe doit comporter au moins 8 caractères.";
        this.valid = false;
        this.showDialog();
      } else if (!uppercaseRegex.test(this.newPassword)) {
        this.passwordError =
          "Le mot de passe doit contenir au moins une lettre majuscule.";
        this.valid = false;
        this.showDialog();
      } else if (
        !(
          specialCharsRegex.test(this.newPassword) ||
          digitRegex.test(this.newPassword)
        )
      ) {
        this.passwordError =
          "Le mot de passe doit contenir au moins un chiffre, un caractère spécial ou un espace.";
        this.valid = false;
        this.showDialog();
      } else if (this.newPassword !== this.cPassword) {
        this.passwordError = "Les mots de passe ne correspondent pas.";
        this.valid = false;
        this.showDialog();
      } else {
        this.passwordError = "Le mot de passe et email sont valides !";
        this.valid = true;
        this.showDialog();
      }
    },
    showDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.two-factor-auth {
  max-width: 25rem;
}
</style>
